
import "../Styles/Gallery.css"
import Gallery1 from "../assets/gallery1.jpeg"
import Gallery2 from "../assets/gallery2.jpeg"
import Gallery3 from "../assets/gallery3.jpeg"
import Gallery4 from "../assets/gallery4.jpeg"
import Gallery5 from "../assets/gallery5.jpeg"
import Gallery6 from "../assets/gallery6.jpeg"
import Gallery7 from "../assets/gallery7.jpeg"
import Gallery8 from "../assets/gallery8.jpeg"
import Gallery9 from "../assets/gallery9.jpeg"
import Gallery10 from "../assets/gallery10.jpeg"
import Gallery11 from "../assets/gallery11.jpeg"
import Gallery12 from "../assets/gallery12.jpeg"

const events = [
  {
    id: 1,
    img: Gallery1,
    // title: "Help Children in Need"
  },
  {
    id: 2,
    img: Gallery2,
    // title: "Support Education"
  },
  {
    id: 3,
    img: Gallery3,
    // title: "Women Empowerment"
  },
  {
    id: 4,
    img: Gallery4,
    // title: "Women Empowerment"
  },
  {
    id: 5,
    img: Gallery5,
    // title: "Women Empowerment"
  },
  {
    id: 6,
    img: Gallery6,
    // title: "Women Empowerment"
  },
  {
    id: 7,
    img: Gallery7,
    // title: "Women Empowerment"
  },
  {
    id: 8,
    img: Gallery8,
    // title: "Women Empowerment"
  },
  {
    id: 9,
    img: Gallery9,
    // title: "Women Empowerment"
  },
  {
    id: 10,
    img: Gallery10,
    // title: "Women Empowerment"
  },
  {
    id: 11,
    img: Gallery11,
    // title: "Women Empowerment"
  },
  {
    id: 12,
    img: Gallery12,
    // title: "Women Empowerment"
  }
];

const EventsGallery = () => {
  return (
    <section className="gallery">
      <h2>Our Events</h2>
      <div className="gallery-list">
        {events.map((event) => (
          <div key={event.id} className="gallery-card">
            <img src={event.img} alt={event.title} height={300}/>
            <h3>{event.title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EventsGallery;
